const header = (state = [], action) => {

	switch (action.type) {

		case 'PUT_HEADER_MENUS':
			const headerMenus = action.payload;

			return {
				...state,
				...headerMenus,
			};

		default:
			return state;
	}

}
export default header;



// WEBPACK FOOTER //
// ./src/reducers/header.js